// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35M-L","content":"styles_content__2lPtQ"};